import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProficiencyEnum } from '@models/profile/proficiency.enum';

const proficiencyValues: Record<ProficiencyEnum, number> = {
  NOTIONS: 1,
  INTERMEDIATE: 2,
  PROFESSIONAL: 3,
  NATIVE_LANGUAGE: 4,
};

@Component({
  selector: 'profile-dots-indicator',
  templateUrl: './dots-indicator.component.html',
  styleUrls: ['./dots-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotsIndicatorComponent {
  proficiencyLevel: number;

  @Input()
  set proficiency(value: ProficiencyEnum) {
    this.proficiencyLevel = proficiencyValues[value];
  }
}
